/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo, useState } from 'react';

import { params } from '../../../../../redux/reducers/reducer';
import { convertFeet } from '../../../../../utils/ConvertFeet';

import LineModel from '../../LineModel';
import DimensionValue from '../../DimensionValue';

const GableFrontLeanToMeasurement = ({ color }) => {

    const [arrowInfosData, setArrowInfosData] = useState({
        widthArrowSize: 0,
        widthArrowPos: [0, 0, 0],
        lengthArrowSize: 0,
        leftLengthArrowPos: [0, 0, 0],
        rightLengthArrowPos: [0, 0, 0],
        heightArrowSize: 0,
        leftHeightArrowPos: [0, 0, 0],
        rightHeightArrowPos: [0, 0, 0],
    });

    const arrowOffset = 0.3;
    const offset = 0.2;

    useMemo(() => {
        const { leanF_p_d, leanF_p_w, leanF_p_h, p_d } = params;
        const alignPosOffset = 0;
        let newArrowPositions = {};
        newArrowPositions = {
            widthArrowSize: leanF_p_w /* + 0.4 */,//->SE3-I6164 ->Dimension isn't coming correct for secondary building//
            widthArrowPos: [alignPosOffset, arrowOffset - 0.1, p_d / 2 + leanF_p_d + arrowOffset],
            lengthArrowSize: leanF_p_d,
            leftLengthArrowPos: [-(leanF_p_w / 2 + offset) + alignPosOffset, 0, p_d / 2 + leanF_p_d / 2 + arrowOffset],
            rightLengthArrowPos: [(leanF_p_w / 2 + offset) + alignPosOffset, 0, p_d / 2 + leanF_p_d / 2 + arrowOffset],
            heightArrowSize: leanF_p_h,
            leftHeightArrowPos: [-(leanF_p_w / 2 + offset) + alignPosOffset, leanF_p_h / 2, p_d / 2 + leanF_p_d + arrowOffset],
            rightHeightArrowPos: [(leanF_p_w / 2 + offset) + alignPosOffset, leanF_p_h / 2, p_d / 2 + leanF_p_d + arrowOffset],
        };
        setArrowInfosData(newArrowPositions);
    }, [ params.p_w, params.p_d, params.leanF_p_w, params.leanF_p_d, params.leanF_p_h ]);

    const { 
        widthArrowSize, widthArrowPos, lengthArrowSize, 
        leftLengthArrowPos, rightLengthArrowPos, heightArrowSize, 
        leftHeightArrowPos, rightHeightArrowPos 
    } = arrowInfosData;


    return params.add_front_lean && (
        <group name='Measurements-gableFrontLeanto'>
            {/* width */}
            <group name='front-arrow' position={widthArrowPos}>
                <LineModel length={widthArrowSize} rotation={[0, 0, Math.PI / 2]} color={color} />
                <DimensionValue position={[0, -0.2, 0.4]} rotation={[0, 0, 0]} value={`${convertFeet(widthArrowSize,false)} L`} slopeAngle={25} type={'lean'} cmpPos={widthArrowPos} />
            </group>

            {/* length */}
            <group name='left-arrow' position={leftLengthArrowPos}>
                <LineModel length={lengthArrowSize} position={[0, 0.2, 0]} rotation={[Math.PI / 2, 0, 0]} color={color} />
                <DimensionValue position={[0, 0, 0]} rotation={[0, -Math.PI / 2, 0]} value={`${convertFeet(lengthArrowSize,false)} W`} slopeAngle={25} type={'lean'} cmpPos={leftLengthArrowPos} />
            </group>
            <group name='right-arrow' position={rightLengthArrowPos}>
                <LineModel length={lengthArrowSize} position={[0, 0.2, 0]} rotation={[Math.PI / 2, 0, 0]} color={color} />
                <DimensionValue position={[0, 0, 0]} rotation={[0, Math.PI / 2, 0]} value={`${convertFeet(lengthArrowSize,false)} W`} slopeAngle={25} type={'lean'} cmpPos={rightLengthArrowPos} />
            </group>

            {/* height */}
            <group name='left-arrow' position={leftHeightArrowPos}>
                <LineModel length={heightArrowSize - 0.2} color={color} position={[0, 0.08, 0]} />
                <DimensionValue position={[-[...`${convertFeet(heightArrowSize)} H`].length * 0.2, 0, -offset]} rotation={[0, 0, 0]} value={`${convertFeet(heightArrowSize,false)} H`} slopeAngle={0} type={'lean'} checkBackSide={true} cmpPos={leftHeightArrowPos} />
            </group>
            <group name='right-arrow' position={rightHeightArrowPos} rotation={[0, -Math.PI / 2, 0]}>
                <LineModel length={heightArrowSize - 0.2} color={color} position={[0, 0.08, 0]} />
                <DimensionValue position={[[...`${convertFeet(heightArrowSize)} H`].length * 0.2, 0, -offset]} rotation={[0, 0, 0]} value={`${convertFeet(heightArrowSize,false)} H`} slopeAngle={0} type={'lean'} checkBackSide={true} cmpPos={rightHeightArrowPos}/>
            </group>
        </group>
    );
};

export default GableFrontLeanToMeasurement;
